import { Tabs } from "@ark-ui/react";
import clsx from "clsx";
import type { ComponentProps } from "react";
import { useTabsContext } from "../TabsContext";

type Props = ComponentProps<typeof Tabs.List>;

const List = ({ children, ...rest }: Props) => {
  const { color, layout } = useTabsContext();

  return (
    <Tabs.List
      className={clsx(
        "relative flex flex-shrink-0 shadow-[inset_0_-1px_0_0_#D6D6D6]",
        layout === "hug" && "overflow-auto",
      )}
      {...rest}
    >
      {children}
      <Tabs.Indicator
        className={clsx(
          "absolute left-[var(--left)] bottom-[1px] w-[var(--width)] h-[2px] transition-[left,right,top,bottom,width,height] will-change-[left,right,top,bottom,width,height] duration-0",
          color === "primary" ? "bg-primary-500" : color === "secondary" ? "bg-blue-400" : undefined,
        )}
      />
    </Tabs.List>
  );
};

export default List;
